import { render } from "./IntroTitle.vue?vue&type=template&id=724b8631&scoped=true"
const script = {}

import "./IntroTitle.vue?vue&type=style&index=0&id=724b8631&lang=scss&scoped=true"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\100\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724b8631"]])

export default __exports__